import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'AppCookiesNotice' };

import { ref } from '@vue';

import { ls } from '@services/ls';

/** Name of key to be used to track user acknowlegment in local storage. */

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const LS_KEY = 'zephyrCookiesNotificationDismissed';

const display = ref(ls.get(LS_KEY) !== 'true');

function dismiss() {
  ls.set(LS_KEY, 'true');

  display.value = false;
}

return { __sfc: true,LS_KEY, display, dismiss }
}

})